import { eLynxObjectTypeEnum } from "../enums/eLynxObjectType";
import { IeLynxObject } from "../models/eLynxObject";

export function RouteFromObjectType(eLynxObject: IeLynxObject): string {
    return eLynxObject.objectType === eLynxObjectTypeEnum.Well
        ? "wells"
        : eLynxObject.objectType === eLynxObjectTypeEnum.Tank
            ? "tanks"
            : eLynxObject.objectType === eLynxObjectTypeEnum.TankBattery
                ? "tankbatteries"
                : eLynxObject.objectType === eLynxObjectTypeEnum.Tag
                    ? "tags"
                    : "devices";
}
